import { useEffect, useState } from "react"
import styled from "@emotion/styled"
import { connect } from "react-redux"
import { compose, map, propEq } from "ramda"
import Select, { components } from "react-select"
import { localized, sortByFieldNameCaseInsensitive } from "js/includes/common/utils"
import { getCredentialReactSelectOptions } from "./common/credentials"
import { FormGroup, Col, ControlLabel, HelpBlock } from "react-bootstrap"
import Creatable from "react-select/creatable"
import { useMounted } from "js/includes/common/hooks"
import Tooltip from "js/includes/components/Tooltip"

const ParameterOption = props => {
  return (
    <div className="code-block">
      <components.Option {...props} />
    </div>
  )
}

const StyledScriptRows = styled.div`
  overflow: hidden;
  white-space: normal;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`

const ScriptParameters = ({
  onChange,
  parameterModal,
  conditionScriptSelector,
  validation,
  values: { runAs, scriptParam },
}) => {
  const [credentialOptions, setCredentialOptions] = useState([])
  const deviceType = parameterModal?.deviceType
  const scriptParameters = parameterModal?.scriptParameters
  const scriptDescription = parameterModal?.scriptDescription

  const mounted = useMounted()

  useEffect(() => {
    const fetchAndSetCredentials = async () => {
      const credentials = await getCredentialReactSelectOptions(deviceType)

      mounted.current && setCredentialOptions(credentials)
    }
    fetchAndSetCredentials()
  }, [deviceType, mounted, setCredentialOptions])

  if (scriptParam && !scriptParameters.includes(scriptParam)) {
    scriptParameters.unshift(scriptParam)
  }

  const options =
    scriptParameters &&
    compose(
      sortByFieldNameCaseInsensitive("label", "ASC"),
      map(p => ({ label: p, value: p })),
    )(scriptParameters)

  return (
    parameterModal && (
      <>
        {scriptDescription && (
          <FormGroup className="m-sm m-b-lg text-align-left">
            <Col xs={4} componentClass={ControlLabel}>
              {localized("general.description")}
            </Col>
            <Col xs={8}>
              <Tooltip placement="bottom" output={scriptDescription}>
                <StyledScriptRows>{scriptDescription}</StyledScriptRows>
              </Tooltip>
            </Col>
          </FormGroup>
        )}
        <FormGroup className="m-sm m-b-lg text-align-left">
          <Col xs={4} componentClass={ControlLabel}>
            {localized("editors.policy.actions.presetParameter")}
          </Col>
          <Col xs={8}>
            <Creatable
              {...{
                autoFocus: true,
                options,
                placeholder: localized("editors.policy.actions.presetParameterDropdownDefault"),
                onChange: selection => {
                  onChange("scriptParam", selection?.value || "")
                },
                matchProp: "label",
                isClearable: true,
                value: options.find(propEq("value", scriptParam)),
                components: { Option: ParameterOption },
              }}
            />
          </Col>
        </FormGroup>

        {!conditionScriptSelector && (
          <FormGroup
            className="m-sm m-b-lg text-align-left"
            validationState={validation.success.runAs === false ? "error" : null}
          >
            <Col xs={4} componentClass={ControlLabel}>
              {localized("editors.policy.actions.runAs")}
            </Col>
            <Col xs={8}>
              <Select
                id="runAs"
                value={credentialOptions.find(propEq("value", runAs))}
                onChange={selection => onChange("runAs", selection.value)}
                options={credentialOptions}
              />
              <HelpBlock className="invalid position-absolute m-t-none">
                {validation.success.runAs === false && validation.message.runAs}
              </HelpBlock>
            </Col>
          </FormGroup>
        )}
      </>
    )
  )
}

export default connect(state => ({
  parameterModal: state.policyEditor.scripting.parameterModal,
  conditionScriptSelector: state.policyEditor.scripting.conditionScriptSelector,
}))(ScriptParameters)
